export const divisionList = {
  name: 'divisionList',
  data () {
    return {
      divisionList: [],
      divisionName: 'All'
    }
  },
  methods: {
    getdivisionList: function () {
      // first check if list is in sessionStorage
      if (sessionStorage.getItem('divisionList')) {
        this.divisionList = JSON.parse(sessionStorage.getItem('divisionList'))
      } else {
        // get from api, and save to sessionStorage
        this.getDivisionFromAPI()
      }
    },
    getDivisionFromAPI: function () {
      var call = '/getPEADivisionList'
      this.$axios.get(call).then(response => {
        this.divisionList = response.data
        // write to sessionStorage
        sessionStorage.setItem('divisionList', JSON.stringify(response.data))
      }).catch(reject => {
        // not able to get to screen
      })
    }
  },
  mounted: function () {
    this.getdivisionList()
  }
}
